import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';

import { ConstantsService } from '../../../common/services/constants.service';
import { GeoService } from '../../../common/services/geo.service';

@Component({
    selector: 'app-login-footer',
    templateUrl: './login-footer.component.html',
    styleUrls: ['./login-footer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoginFooterComponent implements OnInit {
	public phone: string = ConstantsService.SETTINGS.PHONES.MSK;

	constructor(
		private geoService: GeoService,
		private changeDetectorRef: ChangeDetectorRef,
	) { }

	public ngOnInit(): void {
		this.geoService
			.getPhoneByIp()
			.subscribe((phone: string) => {
				this.phone = phone;
				this.changeDetectorRef.markForCheck();
			});
	}
}
